import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

// Firebase configuration
// These values are loaded from environment variables (REACT_APP_*) or use defaults
// Make sure your .env file has REACT_APP_FIREBASE_* variables set
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyAYJUwPt31l8gC8EQ-Jvbbu5QyKfMmswQY",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "alexa-portal.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "alexa-portal",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "alexa-portal.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "533867129230",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:533867129230:web:484478bcf6b1d8a1769cdf"
};

// Validate configuration
if (!firebaseConfig.apiKey || firebaseConfig.apiKey === "YOUR_API_KEY") {
  console.error('❌ Firebase API key is missing or invalid.');
  console.error('   Please set REACT_APP_FIREBASE_API_KEY in your .env file');
  console.error('   Current apiKey:', firebaseConfig.apiKey);
}

// Log config status (without exposing sensitive data)
console.log('🔧 Firebase Config Status:');
console.log('   Project ID:', firebaseConfig.projectId);
console.log('   Auth Domain:', firebaseConfig.authDomain);
console.log('   API Key:', firebaseConfig.apiKey ? `${firebaseConfig.apiKey.substring(0, 10)}...` : 'MISSING');

// Initialize Firebase
let app;
try {
  app = initializeApp(firebaseConfig);
  console.log('✅ Firebase initialized successfully');
} catch (error) {
  console.error('❌ Firebase initialization error:', error);
  console.error('   Error code:', error.code);
  console.error('   Error message:', error.message);
  throw error;
}

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);
export default app;

